import React, { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode,
  className?: string,
  style?: any
}

const CustomButton: React.FC<Props> = ({
  children,
  className,
  onSubmit,
  style,
  type,
  disabled,
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  return (
    <button 
      disabled={disabled} onClick={onClick} 
      type={type} style={style} 
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className} onSubmit={onSubmit}
    >
      {children}
    </button>
  )
}

export default CustomButton